import s from "../../_styles/common/light.js";
function g(n) {
  const {
    infoColor: o,
    successColor: r,
    warningColor: i,
    errorColor: l,
    textColor2: e,
    progressRailColor: t,
    fontSize: c,
    fontWeight: C
  } = n;
  return {
    fontSize: c,
    fontSizeCircle: "28px",
    fontWeightCircle: C,
    railColor: t,
    railHeight: "8px",
    iconSizeCircle: "36px",
    iconSizeLine: "18px",
    iconColor: o,
    iconColorInfo: o,
    iconColorSuccess: r,
    iconColorWarning: i,
    iconColorError: l,
    textColorCircle: e,
    textColorLineInner: "rgb(255, 255, 255)",
    textColorLineOuter: e,
    fillColor: o,
    fillColorInfo: o,
    fillColorSuccess: r,
    fillColorWarning: i,
    fillColorError: l,
    lineBgProcessing: "linear-gradient(90deg, rgba(255, 255, 255, .3) 0%, rgba(255, 255, 255, .5) 100%)"
  };
}
const f = {
  name: "Progress",
  common: s,
  self: g
}, p = f;
export {
  p as default,
  g as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/progress/styles/light.js
// module id = 969
// module chunks = 67